import requestAction from '../../utils/requestAction'
import { pushAlert } from '../alert'

export const sendPasswordRecovery = (params: string, email: string) =>
  requestAction('PASSWORD_RECOVERY', params)('auth/password-recovery', 'POST', { email },
    (dispatch) => dispatch(pushAlert('Te enviamos un mail a tu casilla para recuperar tu contraseña')))
